import {UserAdsError} from './UserAdsError.js'

export class GetOldestC2bAppraisableUserAdError extends UserAdsError {
  #message
  static create({message}) {
    return new GetOldestC2bAppraisableUserAdError({message})
  }

  constructor({message}) {
    super()
    this.#message = message
  }

  toJSON() {
    return {message: this.#message}
  }
}
